/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_DescriptionInputs */

const en_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We offer easy and affordable pricing with no commitment.`)
};

const fr_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous offrons une tarification simple et abordable sans engagement.`)
};

const de_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bieten einfache und günstige Preise ohne Vertragsbindung.`)
};

const it_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offriamo prezzi facili e convenienti, senza impegno.`)
};

const ru_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы предлагаем простые и доступные цены без каких-либо обязательств.`)
};

const es_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofrecemos precios fáciles y asequibles sin compromiso.`)
};

const zh_cn2_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们提供简单便捷且价格实惠的定价方案，无需任何承诺。`)
};

const ja_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちは、契約義務のない、簡単で手頃な価格を提供しています。`)
};

const hi_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम बिना किसी प्रतिबद्धता के आसान और किफायती मूल्य निर्धारण की पेशकश करते हैं।`)
};

const pt_pt2_signup_description = /** @type {(inputs: Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferecemos preços fáceis e acessíveis, sem compromisso.`)
};

/**
* | output |
* | --- |
* | "We offer easy and affordable pricing with no commitment." |
*
* @param {Signup_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_description = /** @type {((inputs?: Signup_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_description(inputs)
	if (locale === "de") return de_signup_description(inputs)
	if (locale === "it") return it_signup_description(inputs)
	if (locale === "ru") return ru_signup_description(inputs)
	if (locale === "es") return es_signup_description(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_description(inputs)
	if (locale === "ja") return ja_signup_description(inputs)
	if (locale === "hi") return hi_signup_description(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_description(inputs)
	return en_signup_description(inputs)
});